import * as THREE from 'three';

export type ReplayCameraMode = 'cockpit' | 'birdseye' | 'spectator';

export class ReplayCameras {
  public mode: ReplayCameraMode = 'cockpit';
  private spectatorAnchor = new THREE.Vector3();
  private hasSpectatorAnchor = false;

  constructor(private camera: THREE.PerspectiveCamera) {}

  public setMode(mode: ReplayCameraMode) {
    this.mode = mode;
    this.hasSpectatorAnchor = false;
  }

  public update(
    carPos: THREE.Vector3,
    carQuat: THREE.Quaternion,
    steeringAngle: number,
    shoulderCheck: string | null
  ) {
    if (this.mode === 'cockpit') {
      // 1. Cockpit Perspective: Eye point directly in front of the left-hand-drive steering wheel (+0.38)
      const eyeOffset = new THREE.Vector3(0.38, 1.10, 0.05).applyQuaternion(carQuat).add(carPos);
      this.camera.position.copy(eyeOffset);

      const lookQuat = carQuat.clone();
      if (shoulderCheck === 'left') {
        lookQuat.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI * 0.6));
      } else if (shoulderCheck === 'right') {
        lookQuat.multiply(new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI * 0.6));
      }

      const forward = new THREE.Vector3(0, 0, 10).applyQuaternion(lookQuat);
      this.camera.up.set(0, 1, 0);
      this.camera.lookAt(eyeOffset.clone().add(forward));
    } else if (this.mode === 'birdseye') {
      // 2. Bird's Eye Perspective: Top-Down Aerial View
      const topPos = carPos.clone().add(new THREE.Vector3(0, 16, 0));
      this.camera.position.copy(topPos);

      const forwardVec = new THREE.Vector3(0, 0, 1).applyQuaternion(carQuat);
      this.camera.up.copy(forwardVec);
      this.camera.lookAt(carPos);
    } else if (this.mode === 'spectator') {
      // 3. Spectator / Road User Perspective: Stationed roadside watching the vehicle pass
      if (!this.hasSpectatorAnchor || this.spectatorAnchor.distanceTo(carPos) > 35) {
        // Find a roadside observation spot 8-12m off to the side
        const sideOffset = new THREE.Vector3(8.5, 1.8, 6.0).applyQuaternion(carQuat);
        this.spectatorAnchor.copy(carPos).add(sideOffset);
        this.hasSpectatorAnchor = true;
      }

      this.camera.position.copy(this.spectatorAnchor);
      this.camera.up.set(0, 1, 0);
      this.camera.lookAt(carPos.clone().add(new THREE.Vector3(0, 0.8, 0)));
    }
  }
}
